import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "You will be redirected shortly. If not, please refresh the page.", -1)

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { AuthenticationServiceInterface } from '@/services/authentication/authenticationServiceInterface';
import { onMounted } from 'vue';
import router from '@/router';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

onMounted(async () => {
  const account = await authenticationService.doLogin();
  if (account) {
    store.commit('setAccount', account);
    router.push('/');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          title: "Authentication.",
          subtitle: ""
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createVNode(Text, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})